function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "company-logo-placeholder");

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 252,
    height: 202,
    viewBox: "0 0 252 202"
  }, props), _ref, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 250,
    height: 200,
    style: {
      "fill": "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "251 198 251 201 248 201",
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.05,
    y1: 201,
    x2: 6.98,
    y2: 201,
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2,
      "strokeDasharray": "5.95121955871582,5.95121955871582"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 201 1 201 1 198",
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 192.12,
    x2: 1,
    y2: 6.94,
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2,
      "strokeDasharray": "5.878787994384766,5.878787994384766"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1 4 1 1 4 1",
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.95,
    y1: 1,
    x2: 245.02,
    y2: 1,
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2,
      "strokeDasharray": "5.95121955871582,5.95121955871582"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248 1 251 1 251 4",
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251,
    y1: 9.88,
    x2: 251,
    y2: 195.06,
    style: {
      "fill": "none",
      "stroke": "#5481a3",
      "strokeMiterlimit": 10,
      "strokeWidth": 2,
      "strokeDasharray": "5.878787994384766,5.878787994384766"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.08,81.44a11.31,11.31,0,0,1-.92,3.5,7.7,7.7,0,0,1-1.89,2.62,8.21,8.21,0,0,1-2.84,1.64,11.62,11.62,0,0,1-3.77.57,9.26,9.26,0,0,1-4-.82,8.71,8.71,0,0,1-3-2.35A10.89,10.89,0,0,1,52.71,83,15.22,15.22,0,0,1,52,78.24V75a15.33,15.33,0,0,1,.69-4.72,10.59,10.59,0,0,1,2-3.64,8.88,8.88,0,0,1,3.08-2.35,9.54,9.54,0,0,1,4.06-.83,11.15,11.15,0,0,1,3.68.56,7.73,7.73,0,0,1,2.8,1.64,8.07,8.07,0,0,1,1.88,2.64,10.9,10.9,0,0,1,.91,3.52H68.9a10.7,10.7,0,0,0-.7-2.77,5.72,5.72,0,0,0-3.49-3.31,8.76,8.76,0,0,0-2.9-.44,7,7,0,0,0-3.19.7,6.77,6.77,0,0,0-2.4,2,9.15,9.15,0,0,0-1.5,3,14.33,14.33,0,0,0-.52,4v3.25a14.43,14.43,0,0,0,.5,3.89,9,9,0,0,0,1.44,3.08,6.7,6.7,0,0,0,2.33,2,6.85,6.85,0,0,0,3.19.72,7.21,7.21,0,0,0,5.11-1.62,7.8,7.8,0,0,0,2.13-4.88Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.68,79.63a11.52,11.52,0,0,1,.61-3.83,9,9,0,0,1,1.71-3,7.88,7.88,0,0,1,2.67-2,8.27,8.27,0,0,1,3.48-.72,8.37,8.37,0,0,1,3.53.72,7.82,7.82,0,0,1,2.68,2,8.79,8.79,0,0,1,1.7,3,11.78,11.78,0,0,1,.6,3.83v.58a11.78,11.78,0,0,1-.6,3.83,8.79,8.79,0,0,1-1.7,3,7.73,7.73,0,0,1-2.67,2,9,9,0,0,1-7,0,7.77,7.77,0,0,1-2.68-2,9,9,0,0,1-1.72-3,11.52,11.52,0,0,1-.61-3.83Zm2.11.58a10.42,10.42,0,0,0,.42,3,7.68,7.68,0,0,0,1.23,2.48,6,6,0,0,0,2,1.69,6.16,6.16,0,0,0,5.47,0,6,6,0,0,0,2-1.69,7.68,7.68,0,0,0,1.23-2.48,10.42,10.42,0,0,0,.42-3v-.58a10.24,10.24,0,0,0-.42-2.94,7.63,7.63,0,0,0-1.23-2.49,6.06,6.06,0,0,0-2-1.72,5.88,5.88,0,0,0-2.76-.64,5.68,5.68,0,0,0-2.71.64,6.13,6.13,0,0,0-2,1.72,7.63,7.63,0,0,0-1.23,2.49,10.24,10.24,0,0,0-.42,2.94Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.92,70.4,98,73.5a8,8,0,0,1,1.1-1.42,6.2,6.2,0,0,1,1.4-1.09,6.59,6.59,0,0,1,1.68-.69,7.33,7.33,0,0,1,2-.25,6.92,6.92,0,0,1,3.59.88,4.89,4.89,0,0,1,2.13,2.81A7.78,7.78,0,0,1,111,72.27a7.21,7.21,0,0,1,1.46-1.17,8.07,8.07,0,0,1,1.8-.77,7.67,7.67,0,0,1,2.13-.28,8,8,0,0,1,2.64.4,4.67,4.67,0,0,1,2,1.24,5.72,5.72,0,0,1,1.22,2.17,10.54,10.54,0,0,1,.42,3.17V89.42h-2.11V77a8,8,0,0,0-.33-2.5,3.84,3.84,0,0,0-1-1.59,3.32,3.32,0,0,0-1.47-.81,6.89,6.89,0,0,0-1.87-.23,5.68,5.68,0,0,0-2.34.48,5.5,5.5,0,0,0-1.69,1.18,5.18,5.18,0,0,0-1.09,1.59,5.38,5.38,0,0,0-.45,1.7V89.42h-2.11V76.85a7,7,0,0,0-.34-2.37,3.7,3.7,0,0,0-1-1.53,3.53,3.53,0,0,0-1.46-.83,7,7,0,0,0-1.89-.24,5.33,5.33,0,0,0-2.11.38,5,5,0,0,0-1.59,1,5.59,5.59,0,0,0-1.12,1.44,8.69,8.69,0,0,0-.7,1.67v13H95.9v-19Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2,80.1a15,15,0,0,1-.48,3.92,9.14,9.14,0,0,1-1.42,3,6.64,6.64,0,0,1-2.27,2,6.41,6.41,0,0,1-3.07.71,7.89,7.89,0,0,1-3.53-.73A6.67,6.67,0,0,1,130,87v9.7h-2.09V70.4h2l.11,2.69a7,7,0,0,1,2.44-2.23,7.24,7.24,0,0,1,3.52-.81,6.77,6.77,0,0,1,3.1.69,6.21,6.21,0,0,1,2.29,2,9.05,9.05,0,0,1,1.42,3,15.39,15.39,0,0,1,.48,4Zm-2.11-.36a13.27,13.27,0,0,0-.34-3.1,7.81,7.81,0,0,0-1-2.49,4.83,4.83,0,0,0-4.28-2.27,6.27,6.27,0,0,0-2,.3,5.22,5.22,0,0,0-1.54.8,5.13,5.13,0,0,0-1.12,1.16,7.23,7.23,0,0,0-.77,1.38v9.12a6.42,6.42,0,0,0,.84,1.34A5,5,0,0,0,132,87a5.64,5.64,0,0,0,1.53.7,6.85,6.85,0,0,0,1.94.26,4.94,4.94,0,0,0,2.49-.61,5,5,0,0,0,1.75-1.67,8,8,0,0,0,1-2.5,13.44,13.44,0,0,0,.34-3.12Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,89.42a6.27,6.27,0,0,1-.28-1.2c-.06-.48-.11-1-.13-1.45a8.12,8.12,0,0,1-1.12,1.16,7.8,7.8,0,0,1-1.46.95,9.11,9.11,0,0,1-1.78.65,8.62,8.62,0,0,1-2.09.24,7.4,7.4,0,0,1-2.52-.4,5.66,5.66,0,0,1-1.94-1.14,5.15,5.15,0,0,1-1.24-1.71,5.59,5.59,0,0,1,.16-4.65A5.48,5.48,0,0,1,149.2,80a8.33,8.33,0,0,1,2.73-1.19,14.31,14.31,0,0,1,3.61-.42h3.9V76.2A4.19,4.19,0,0,0,158.19,73a5.2,5.2,0,0,0-3.67-1.16,6.62,6.62,0,0,0-2,.29,5.33,5.33,0,0,0-1.61.83,3.91,3.91,0,0,0-1.05,1.22,3.09,3.09,0,0,0-.38,1.49l-2.11,0a4.37,4.37,0,0,1,.53-2.07,5.83,5.83,0,0,1,1.48-1.79,7.74,7.74,0,0,1,2.31-1.26,9,9,0,0,1,3-.47,9.48,9.48,0,0,1,2.78.39,5.9,5.9,0,0,1,2.19,1.16A5.24,5.24,0,0,1,161,73.53a6.69,6.69,0,0,1,.51,2.71v9.21q0,.49,0,1c0,.35.06.69.11,1s.12.64.19.94a4.21,4.21,0,0,0,.25.78v.21Zm-6.61-1.51a7.47,7.47,0,0,0,2.11-.29,6.79,6.79,0,0,0,1.77-.8,6.08,6.08,0,0,0,1.37-1.19,5.7,5.7,0,0,0,.93-1.47V80h-3.6a13.26,13.26,0,0,0-2.89.29,6.7,6.7,0,0,0-2.15.84,3.88,3.88,0,0,0-1.35,1.32A3.39,3.39,0,0,0,149,84.2a3.48,3.48,0,0,0,1.16,2.63,3.93,3.93,0,0,0,1.34.79A5.23,5.23,0,0,0,153.26,87.91Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.15,70.4l.07,3.25a8.2,8.2,0,0,1,1.13-1.47A7.15,7.15,0,0,1,171.78,71a7.22,7.22,0,0,1,1.71-.73,7.14,7.14,0,0,1,1.93-.25,7.76,7.76,0,0,1,2.55.39,4.44,4.44,0,0,1,1.91,1.23,5.46,5.46,0,0,1,1.19,2.17,10.68,10.68,0,0,1,.42,3.21V89.42h-2.1V77a8.14,8.14,0,0,0-.31-2.46,3.84,3.84,0,0,0-.9-1.58,3.24,3.24,0,0,0-1.41-.86,6.39,6.39,0,0,0-1.86-.25,5.15,5.15,0,0,0-2,.38,5.23,5.23,0,0,0-1.61,1A6.57,6.57,0,0,0,170,74.72a8.11,8.11,0,0,0-.81,1.68v13h-2.09v-19Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,86.4l5.55-16h2.27l-8.05,22.06c-.17.44-.37.92-.63,1.46a6.62,6.62,0,0,1-1,1.51,5.14,5.14,0,0,1-1.51,1.19,4.69,4.69,0,0,1-2.21.48l-.4,0-.46-.07-.43-.07-.32-.08,0-1.74.57.07.52,0a4.54,4.54,0,0,0,1.49-.22,3.14,3.14,0,0,0,1.14-.65,4.47,4.47,0,0,0,.85-1.08,9.9,9.9,0,0,0,.67-1.49l.91-2.52L184.74,70.4H187Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.28,130.79h12.64v1.83H89.1V107h2.18Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,122.83A11.52,11.52,0,0,1,107,119a9,9,0,0,1,1.71-3,7.88,7.88,0,0,1,2.67-2,8.21,8.21,0,0,1,3.48-.72,8.41,8.41,0,0,1,3.53.72,7.92,7.92,0,0,1,2.68,2,9,9,0,0,1,1.7,3,11.78,11.78,0,0,1,.6,3.83v.58a11.78,11.78,0,0,1-.6,3.83,9,9,0,0,1-1.7,3,7.67,7.67,0,0,1-2.68,2,9,9,0,0,1-7,0,7.77,7.77,0,0,1-2.68-2,8.83,8.83,0,0,1-1.72-3,11.52,11.52,0,0,1-.61-3.83Zm2.11.58a10.42,10.42,0,0,0,.42,3,7.68,7.68,0,0,0,1.23,2.48,6,6,0,0,0,2,1.69,5.72,5.72,0,0,0,2.75.64,5.62,5.62,0,0,0,2.73-.64,6,6,0,0,0,2-1.69,8.11,8.11,0,0,0,1.23-2.48,10.42,10.42,0,0,0,.42-3v-.58a10.24,10.24,0,0,0-.42-2.94,8.05,8.05,0,0,0-1.23-2.49,6,6,0,0,0-2-1.72,5.84,5.84,0,0,0-2.75-.64,5.68,5.68,0,0,0-2.71.64,6,6,0,0,0-2,1.72,7.63,7.63,0,0,0-1.23,2.49,10.24,10.24,0,0,0-.42,2.94Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9,122.94a14.55,14.55,0,0,1,.5-4,9.09,9.09,0,0,1,1.45-3,6.35,6.35,0,0,1,2.31-2,6.75,6.75,0,0,1,3.09-.69,7,7,0,0,1,3.49.82,6.71,6.71,0,0,1,2.41,2.27l.11-2.74h2v18.69a9.53,9.53,0,0,1-.55,3.31,7,7,0,0,1-1.54,2.49,6.57,6.57,0,0,1-2.4,1.56,8.45,8.45,0,0,1-3.14.55,8.6,8.6,0,0,1-3.63-.81,8.8,8.8,0,0,1-1.65-1A7.06,7.06,0,0,1,128,137l1.18-1.27a7.68,7.68,0,0,0,2.46,2.08,6.19,6.19,0,0,0,2.85.66,6.63,6.63,0,0,0,2.4-.41,4.84,4.84,0,0,0,1.76-1.2,5.17,5.17,0,0,0,1.1-1.9,7.93,7.93,0,0,0,.38-2.54v-2.21a6.69,6.69,0,0,1-2.41,2.07,7.64,7.64,0,0,1-3.48.74,6.4,6.4,0,0,1-3.06-.71,6.73,6.73,0,0,1-2.3-2,9.18,9.18,0,0,1-1.45-3.05,14.16,14.16,0,0,1-.5-3.92Zm2.12.36a13.85,13.85,0,0,0,.34,3.11,7.61,7.61,0,0,0,1,2.48,5,5,0,0,0,1.73,1.66,4.93,4.93,0,0,0,2.49.59,6.64,6.64,0,0,0,2-.26,5.42,5.42,0,0,0,1.53-.73,5.06,5.06,0,0,0,1.16-1.1,7.17,7.17,0,0,0,.85-1.39v-8.84a7.46,7.46,0,0,0-.77-1.41,5.53,5.53,0,0,0-1.12-1.2,5.26,5.26,0,0,0-1.54-.82,6,6,0,0,0-2-.31,5,5,0,0,0-2.51.6,5.14,5.14,0,0,0-1.74,1.67,7.57,7.57,0,0,0-1,2.49,13.82,13.82,0,0,0-.34,3.1Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,122.83a11.52,11.52,0,0,1,.61-3.83,9,9,0,0,1,1.71-3,7.88,7.88,0,0,1,2.67-2,8.27,8.27,0,0,1,3.48-.72,8.41,8.41,0,0,1,3.53.72,7.82,7.82,0,0,1,2.68,2,9,9,0,0,1,1.7,3,11.78,11.78,0,0,1,.6,3.83v.58a11.78,11.78,0,0,1-.6,3.83,9,9,0,0,1-1.7,3,7.73,7.73,0,0,1-2.67,2,9,9,0,0,1-7,0,7.77,7.77,0,0,1-2.68-2,8.83,8.83,0,0,1-1.72-3,11.52,11.52,0,0,1-.61-3.83Zm2.11.58a10.42,10.42,0,0,0,.42,3,7.68,7.68,0,0,0,1.23,2.48,6,6,0,0,0,2,1.69,6.16,6.16,0,0,0,5.47,0,6,6,0,0,0,2-1.69,7.68,7.68,0,0,0,1.23-2.48,10.42,10.42,0,0,0,.42-3v-.58a10.24,10.24,0,0,0-.42-2.94,7.63,7.63,0,0,0-1.23-2.49,6,6,0,0,0-2-1.72A5.84,5.84,0,0,0,155,115a5.68,5.68,0,0,0-2.71.64,6.13,6.13,0,0,0-2,1.72,7.63,7.63,0,0,0-1.23,2.49,10.24,10.24,0,0,0-.42,2.94Z",
    transform: "translate(0.5 0.5)",
    style: {
      "fill": "#5481a3",
      "opacity": 0.5
    }
  })));
};

export default __webpack_public_path__ + "static/media/company-logo-placeholder.f9c87508.svg";
export { SvgComponent as ReactComponent };